import { render, staticRenderFns } from "./srgs.vue?vue&type=template&id=2022971c&scoped=true&"
import script from "./srgs.vue?vue&type=script&lang=js&"
export * from "./srgs.vue?vue&type=script&lang=js&"
import style0 from "./srgs.vue?vue&type=style&index=0&id=2022971c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2022971c",
  null
  
)

export default component.exports